import useResource from 'app/hooks/useResource';

import {
  moments as resource
} from 'app/resources';

import {
  getMoments,
  setMomentParams
} from 'app/actions/moments';

import {
  createMoment,
  updateMoment,
  destroyMoments
} from 'app/services/moments';

const useMoments = () => {
  return useResource({
    resource,
    getResource: getMoments,
    createResource: createMoment,
    updateResource: updateMoment,
    destroyResource: destroyMoments,
    setResourceParams: setMomentParams
  });
}

export default useMoments;
